module.exports = __webpack_public_path__ + "static/media/best-aroma.2cc4e912.png";